// Sort threads by createdAt in descending order (most recent first)

export const sortThreadsByNewest = threads => {
  return [...threads].sort((a, b) => {
    const dateA = new Date(a.createdAt).getTime();
    const dateB = new Date(b.createdAt).getTime();
    return dateB - dateA;
  });
};